import { cn } from "../../lib/utils";
import { type SVGProps } from "react";
import { type IconName } from "./types";

export function Icon({
  name,
  className,
  ...props
}: SVGProps<SVGSVGElement> & {
  name: IconName;
}) {
  return (
    <svg
      // width and height are set to 1em so that the component can use the font size to scale the icon
      className={cn("w-[1em] h-[1em]", className)}
      {...props}
    >
      <use href={`/iconsprite.svg#${name}`} />
    </svg>
  );
}
